<template>
    <b-card header="Sign in">
        <b-form @submit.prevent="onSubmit" >
            <b-form-group id="email-label" label="Email address:" label-for="email">
                <b-form-input id="email" v-model="login" type="email" required placeholder="Enter email"></b-form-input>
            </b-form-group>
            <b-form-group id="password-label" label="Password:" label-for="password">
                <b-form-input id="password" v-model="password" type="password" required placeholder="Enter password"></b-form-input>
            </b-form-group>
            <b-button type="submit" variant="primary">Sign in</b-button>
        </b-form>
    </b-card>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters(['user']),
    nextRoute () {
      return this.$route.query.redirect || '/'
    }
  },
  data () {
    return {
      login: '',
      password: ''
    }
  },
  watch: {
    user (auth) {
      if(!!auth){
        this.$router.replace(this.nextRoute)
      }
    }
  },
  methods: {
    async onSubmit () {
      await this.$auth.login(this.login, this.password)
    }
  }
}
</script>